/// <amd-module name="Test/TestPlansHubRefresh/PostTTIModule/Redux/PostTTIActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const PostTTIActions = {
    /**
     * loadPostTTIModules: fetches dependency upfront after TTI
     */
    loadPostTTIModules: () => createAction(PostTTIActionsTypes.loadPostTTIModules)
};

export const enum PostTTIActionsTypes {
    loadPostTTIModules = "TestHubPostTTI/loadPostTTIModules"
}

export type PostTTIActions = ActionsUnion<typeof PostTTIActions>;
